import { COMPLETE_TOUR, DATA_LOADED, SET_UP, EXECUTE_ACTION, ACHIEVE, OPEN_ACHIEVEMENT_BANNER, CLOSE_ACHIEVEMENT_BANNER} from "./constants";
import { updateArray } from "./utils";

const initialState = {
  loading: true,
  hasBeenSetUp: false,
  toursCompleted: [],
  actionsExecuted: [],
  achievements: [],
  achievementsAvailable: [],
  banner: null,
  showBanner: false,
  bannerOpen: false
};
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_UP:
      return {
        ...state,
        _loadData: action.payload.loadData,
        _executeAction: action.payload.executeAction,
        _completeTour: action.payload.completeTour,
        _saveAchievement: action.payload.saveAchievement,
        hasBeenSetUp: true
      }
    case DATA_LOADED:
      return {
        ...state,
        toursCompleted: action.payload.toursCompleted,
        actionsExecuted: action.payload.actionsExecuted,
        achievements: action.payload.achievements,
        achievementsAvailable: action.payload.achievementsAvailable,
        loading: false
      }
    case COMPLETE_TOUR:
      return {
        ...state,
        toursCompleted: [...state.toursCompleted, action.payload]
      };
    case EXECUTE_ACTION:
      const { actionsExecuted } = state
      const actionId = action.payload
      if (actionsExecuted.find(action => action.actionId === actionId)){
        const index = actionsExecuted.findIndex(action => action.actionId === actionId)
        return {
          ...state,
          actionsExecuted: updateArray(actionsExecuted, index, (action) => ({...action, use: action.use + 1}))
        }

      } else {
        return {
          ...state,
          actionsExecuted: [...actionsExecuted, {actionId, use: 1}]
        }
      }
    case ACHIEVE:
      const achievementId = action.payload
      const achievement = state.achievementsAvailable.find(a => a.achievementId === achievementId)
      return {
        ...state,
        achievements: [...state.achievements, {
          title: achievement.title,
          achievementId: achievementId,
          description: achievement.description,
          image: achievement.image
        }]
      }
    case OPEN_ACHIEVEMENT_BANNER:
      return {
        ...state,
        showBanner: true,
        bannerOpen: true,
        banner: action.payload
      }
    case CLOSE_ACHIEVEMENT_BANNER:
      return {
        ...state,
        bannerOpen: false
      }
    default:
      return state;
  }
};
